import { useEffect, useState } from "react";
import { apiFetch } from "../apiClient";

function formatStatus(code) {
    if (code == null) return "�";
    const n = Number(code);
    if (Number.isNaN(n)) return String(code);
    if (n >= 200 && n < 300) return `${n} OK`;
    if (n >= 400 && n < 500) return `${n} client`;
    if (n >= 500) return `${n} server`;
    return String(code);
}

export default function AutoTradeRunsCard({ userId, mode }) {
    const [runs, setRuns] = useState([]);
    const [loading, setLoading] = useState(false);
    const [err, setErr] = useState("");

    const load = async () => {
        if (!userId) return;
        setLoading(true);
        setErr("");
        try {
            const qs = new URLSearchParams({
                user_id: userId,
                limit: "20",
            });
            if (mode) qs.set("mode", mode);

            const d = await apiFetch(`/api/ai/auto-trade-runs?${qs.toString()}`);

            if (!d || d.ok === false) {
                setErr(d?.error || "Could not load auto-trade runs.");
                setRuns([]);
            } else {
                setRuns(d.runs || []);
            }
        } catch (e) {
            console.error("AutoTradeRunsCard load error:", e);
            setErr("Could not load auto-trade runs.");
            setRuns([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        load();
    }, [userId, mode]);

    return (
        <div className="p-4 bg-zinc-900 rounded-2xl space-y-3">
            <div className="flex items-center justify-between">
                <h3 className="text-lg font-semibold">Auto-Trade Runs (Cron)</h3>
                <button
                    type="button"
                    onClick={load}
                    className="px-3 py-1 text-xs rounded bg-zinc-700 hover:bg-zinc-600"
                >
                    {loading ? "Loading�" : "Refresh"}
                </button>
            </div>

            {err && <div className="text-xs text-red-400">{err}</div>}

            {!err && runs.length === 0 && !loading && (
                <div className="text-xs text-zinc-400">
                    No cron runs recorded yet for this account.
                </div>
            )}

            {runs.length > 0 && (
                <div className="max-h-48 overflow-y-auto text-[11px] space-y-1">
                    {runs.map((r) => (
                        <div
                            key={r.id}
                            className="flex justify-between py-1 border-b border-zinc-800 last:border-0"
                        >
                            <div className="mr-2 min-w-0">
                                <div className="font-medium text-zinc-100 truncate">
                                    {r.created_at}
                                </div>
                                <div className="text-zinc-400">
                                    Mode: {r.mode || "?"} � EQ max {r.max_equity_trades} �
                                    OP max {r.max_option_trades}
                                </div>
                                {(r.equity_error || r.options_error) && (
                                    <div className="text-[10px] text-amber-300 truncate">
                                        {r.equity_error && `EQ: ${r.equity_error} `}
                                        {r.options_error && `OP: ${r.options_error}`}
                                    </div>
                                )}
                            </div>

                            <div className="text-right text-[11px] ml-2">
                                <div
                                    className={
                                        r.equity_status >= 200 &&
                                            r.equity_status < 300
                                            ? "text-emerald-400"
                                            : "text-zinc-400"
                                    }
                                >
                                    EQ {formatStatus(r.equity_status)}
                                </div>
                                <div
                                    className={
                                        r.options_status >= 200 &&
                                            r.options_status < 300
                                            ? "text-emerald-400"
                                            : "text-zinc-400"
                                    }
                                >
                                    OP {formatStatus(r.options_status)}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
// JavaScript source code
